/* Isla Elevate - scroll choreography + parallax
   One file, no dependencies. Remove the include in theme.liquid to revert.
   Dawn's native reveal (scroll-trigger) stays in charge of standard sections;
   this layer only animates what native cannot reach. */
(function () {
  'use strict';
  var doc = document;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (doc.readyState !== 'loading') { fn(); }
    else { doc.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var html = doc.documentElement;
    html.classList.add('iv-ready');

    /* ---------- 1. Collect reveal targets ----------
       Only elements Dawn's native scroll-trigger does NOT animate:
       custom page content (body_html grids/cards) + opt-in hooks. */
    var groupSelectors = [
      '.mbg-book-grid',
      '.isla-steps',
      '.iv-group'
    ];
    var singleSelectors = [
      '.isla-reveal',
      '.isla-rule'
    ];

    function nativelyAnimated(el) {
      return el.classList.contains('scroll-trigger') || el.closest('.scroll-trigger') !== null;
    }

    var targets = [];

    groupSelectors.forEach(function (sel) {
      doc.querySelectorAll(sel).forEach(function (group) {
        if (nativelyAnimated(group)) { return; }
        Array.prototype.slice.call(group.children).forEach(function (kid, i) {
          kid.classList.add('iv');
          kid.style.transitionDelay = Math.min(i * 90, 450) + 'ms';
          targets.push(kid);
        });
      });
    });

    doc.querySelectorAll(singleSelectors.join(',')).forEach(function (el) {
      if (nativelyAnimated(el) || el.classList.contains('iv')) { return; }
      el.classList.add('iv');
      targets.push(el);
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('iv-in'); });
      html.classList.add('iv-static');
      revealHero();
      return;
    }

    /* ---------- 2. Reveal on scroll ---------- */
    if (targets.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('iv-in');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      targets.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
          el.classList.add('iv-in');
        } else {
          io.observe(el);
        }
      });
    }

    /* ---------- 3. Gentle parallax on large media ---------- */
    var plxEls = [];
    doc.querySelectorAll('.image-with-text__media img, [data-iv-parallax] img').forEach(function (img) {
      var host = img.closest('.image-with-text__media') || img.parentElement;
      if (!host) { return; }
      host.classList.add('iv-plx-host');
      img.classList.add('iv-plx');
      plxEls.push({ img: img, host: host, visible: false });
    });

    if (plxEls.length) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          for (var i = 0; i < plxEls.length; i++) {
            if (plxEls[i].host === entry.target) { plxEls[i].visible = entry.isIntersecting; }
          }
        });
      }, { rootMargin: '10% 0px 10% 0px' });
      plxEls.forEach(function (p) { vio.observe(p.host); });

      var ticking = false;
      var onScroll = function () {
        if (ticking) { return; }
        ticking = true;
        requestAnimationFrame(function () {
          var vh = window.innerHeight;
          plxEls.forEach(function (p) {
            if (!p.visible) { return; }
            var r = p.host.getBoundingClientRect();
            var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
            var shift = Math.max(-1, Math.min(1, progress)) * -22;
            p.img.style.transform = 'scale(1.12) translateY(' + shift.toFixed(1) + 'px)';
          });
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---------- 4. Hero entrance ---------- */
    function revealHero() {
      var hero = doc.querySelector('.isla-vhero');
      if (!hero) { return; }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { hero.classList.add('iv-hero-in'); });
      });
    }
    revealHero();
  });
})();
